import axios from 'axios';

   const API_BASE_URL = 'https://contentvertex.zealcart.com/api';

   const api = axios.create({
     baseURL: API_BASE_URL,
     headers: {
       'Content-Type': 'application/json',
       'Accept': 'application/json',
     },
   });

   // Add token to requests if it exists
   api.interceptors.request.use((config) => {
     const token = localStorage.getItem('auth_token');
     if (token) {
       config.headers.Authorization = `Bearer ${token}`;
     }
     return config;
   });

   export const authAPI = {
     register: (data) => api.post('/auth/register', data),
     login: (data) => api.post('/auth/login', data),
     getUser: () => api.get('/user'),
   };

   export const contentAPI = {
     generate: (data) => api.post('/content/generate', data),
     getArticle: (id) => api.get(`/content/article/${id}`),
     listArticles: () => api.get('/articles'),
   };

   export const subscriptionAPI = {
     getSubscription: () => api.get('/subscription'),
     getUsage: () => api.get('/subscription/usage'),
     // WordPress Sites methods
  getWordPressSites: () => 
    api.get('/wordpress-sites'),

  addWordPressSite: (siteData) => 
    api.post('/wordpress-sites', siteData),

  testWordPressSite: (siteId) => 
    api.post(`/wordpress-sites/${siteId}/test`),

  deleteWordPressSite: (siteId) => 
    api.delete(`/wordpress-sites/${siteId}`),

  publishToWordPress: (siteId, articleData) => 
    api.post(`/wordpress-sites/${siteId}/publish`, articleData),
   };
   export default api;
